import { Controller } from "@hotwired/stimulus"
import Dismiss from "flowbite/lib/esm/components/dismiss"

let sequence = 0

// Flowbite dismiss, attached to the dismissable element:
//
//   <div data-controller="dismiss" role="alert">
//     … <button data-dismiss-target="trigger">Close</button>
//   </div>
// One instance per alert element, keyed by its id (override: true); a
// generated id only covers elements rendered without one.
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    if (!this.hasTriggerTarget) return

    this.dismiss = new Dismiss(
      this.element,
      this.triggerTarget,
      {},
      {
        id: this.element.id || `dismiss-${++sequence}`,
        override: true,
      },
    )
  }

  disconnect() {
    this.dismiss?.destroyAndRemoveInstance()
    this.dismiss = null
  }
}
